export const environment = {
  production: true,
  urlAPI: 'https://apicalculadoracupraprod.easymarketingred.es/api/',
  urlServer: 'https://apicalculadoracupraprod.easymarketingred.es/'
};
